import { useCallback, useState } from 'react';
import OnboardingLayout from '../pages/onboarding/OnboardingLayout';
import { WithAccountsSelectionDialog } from './WithAccountsSelectionDialog';
import { AccountSelectionCreateAccount } from './AccountSelectionCreateAccount';
import { useAccountSelectionContext } from './AccountSelectionContext';

export const AccountSelectionPage = () => {
  const { accounts } = useAccountSelectionContext();
  const [isRenderPopover, setIsRenderPopover] = useState(true);

  const onGoBack = useCallback(
    () => setIsRenderPopover(!!accounts && accounts.length !== 1),
    [accounts],
  );

  if (isRenderPopover) {
    return (
      <OnboardingLayout withLogout={true}>
        <WithAccountsSelectionDialog
          children={<></>}
          isBlockingAccountSelection
          onCreateNewAccountClick={() => setIsRenderPopover(false)}
        />
      </OnboardingLayout>
    );
  }

  return <AccountSelectionCreateAccount onGoBack={onGoBack} />;
};
